import Search_1 from './Search_1';
import Search_qr from './Search_qr';
import Search_11 from './Search_11';

export const Search = {
  Search_1: Search_1,
  Search_qr: Search_qr,
  Search_11: Search_11,
};
